module.exports = __webpack_public_path__ + "static/tada-video-c98e991aa0d65a9f5af96bcc002bc4d4.mp4";